var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 19,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 27,
    height: 19,
    rx: 3.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85333 13.7152H7.15707L5.88509 8.66031C5.82471 8.42779 5.69652 8.22222 5.50796 8.12534C5.03737 7.88186 4.51882 7.68809 3.95312 7.59036V7.39575H6.68566C7.06279 7.39575 7.34564 7.68809 7.39278 8.02761L8.05276 11.6739L9.74819 7.39575H11.3973L8.85333 13.7152ZM12.3401 13.7152H10.7382L12.0573 7.39575H13.6593L12.3401 13.7152ZM15.7318 9.14643C15.779 8.80606 16.0618 8.61145 16.3918 8.61145C16.9104 8.56259 17.4752 8.66032 17.9466 8.90295L18.2295 7.54234C17.7581 7.34773 17.2395 7.25 16.7689 7.25C15.2141 7.25 14.0827 8.12534 14.0827 9.3402C14.0827 10.2644 14.8841 10.7497 15.4498 11.042C16.0618 11.3335 16.2975 11.5281 16.2504 11.8196C16.2504 12.2569 15.779 12.4515 15.3084 12.4515C14.7427 12.4515 14.177 12.3057 13.6593 12.0623L13.3764 13.4237C13.9421 13.6663 14.5541 13.7641 15.1198 13.7641C16.8632 13.8121 17.9466 12.9376 17.9466 11.625C17.9466 9.97206 15.7318 9.87518 15.7318 9.14643ZM23.5531 13.7152L22.2811 7.39575H20.9149C20.632 7.39575 20.3492 7.59036 20.2549 7.88186L17.8995 13.7152H19.5486L19.8778 12.7918H21.904L22.0926 13.7152H23.5531ZM21.1506 9.09757L21.6212 11.4793H20.302L21.1506 9.09757Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.a4f483cf10da17328e76e993e75b806d.svg";
export { ForwardRef as ReactComponent };